import './style.css';
import { daysToMs, hoursToMs, minutesToMs, secondsToMs } from '../../constants';

function CountdownDetails(props) {
  const diff = props.diff < 0 ? -props.diff : props.diff; //also count up if final date in the past (diff < 0)

  const days = Math.floor(diff / daysToMs).toLocaleString('de-DE');
  const hours = Math.round(diff / hoursToMs).toLocaleString('de-DE');
  const minutes = Math.round(diff / minutesToMs).toLocaleString('de-DE');
  const seconds = Math.round(diff / secondsToMs).toLocaleString('de-DE');

  return (
    <div className="details-container">
      <span>&#916; Tage</span> <span className="value">{days}</span>
      <span>&#916; Stunden</span> <span className="value"> {hours}</span>
      <span>&#916; Minuten</span> <span className="value"> {minutes}</span>
      <span>&#916; Sekunden</span> <span className="value"> {seconds}</span>
    </div>
  );
}

export default CountdownDetails;
